export default class UserException {
  constructor(message) {
    this.message = message
  }
  message = ""
}
